export default __webpack_public_path__ + "static/media/icon_settings.95ea0ea9.svg";